<template>
<md-whiteframe class="project-box">
    <md-dialog-confirm
        :md-title="confirm.title"
        :md-content-html="getConfirmContent()"
        :md-ok-text="confirm.ok"
        :md-cancel-text="confirm.cancel"
        @close="deleteProjectConfirm"
        ref="deleteProjectDialog">
    </md-dialog-confirm>
    <md-card class="project-box-content">
        <md-card-header>
            <div class="md-title">{{project.title}}</div>
            <div class="md-subhead" v-if="owner">Owner: {{owner.username}}</div>
        </md-card-header>
        <md-card-content>
            <div class="md-subtitle">Last Updated</div>
            <div class="md-caption">{{lastChanged}}</div>
        </md-card-content>
        <md-card-actions>
<!--             <router-link tag="md-button" :to="{name: 'projectVersion', params: {id: project.id, version: project.showVersion}}" :click="selectProject" v-if="project.showVersion">
                Show
            </router-link> -->
            <router-link tag="md-button" :to="{name: 'project', params: {id: project.id}}" :click="selectProject" class="md-icon-button">
                <md-icon>mode_edit</md-icon>
                <md-tooltip>Edit Project</md-tooltip>
            </router-link>
            <md-button @click="deleteProject" v-if="user.uid === project.ownerUID" class="md-icon-button">
                <md-icon>delete</md-icon>
                <md-tooltip>Delete Project</md-tooltip>
            </md-button>
        </md-card-actions>
    </md-card>
</md-whiteframe>
</template>

<script>
/**
 * Display a Project Box - summary for a Project w/ Actions
 */
import moment from 'moment';
import { mapGetters } from 'vuex';

const ProjectBox = {
    name: 'ProjectBox',
    props: ['project'],
    data: function() {
        return {
            confirm: {
                title: 'Confirm Project Delete',
                ok: 'yes',
                cancel: 'Cancel'
            }
        };
    },
    methods: {
        selectProject() {
            
        },
        deleteProject() {
            this.$refs.deleteProjectDialog.open();
        },
        deleteProjectConfirm(type) {
            if (type === 'ok') {
                this.$store.dispatch('deleteProject', this.project.id);
                this.$router.replace('/dashboard');
            }
        },
        getConfirmContent() {
            const numCollaborators = this.project.collaborators ? Object.values(this.project.collaborators).length : 0;
            const numCues = this.project.cues ? Object.values(this.project.cues).length : 0;
            return `Warning, you are about to delete a project with <strong>${numCollaborators}</strong> collaborators and <strong>${numCues}</strong> cues already written! Please confirm you would like to delete this project.`;
        }
    },
    computed: {
        ...mapGetters([
            'user',
            'userByUID'
        ]),
        lastChanged: function() {
            if (this.project.lastChangedDate) {
                return moment(this.project.lastChangedDate).format('MM/DD/YYYY hh:mm:ss a');
            }
            return moment().format('MM/DD/YYYY hh:mm:ss a');
        },
        owner: function() {
            return this.userByUID(this.project.ownerUID);
        }
    }
};
export default ProjectBox;

</script>

<style lang="scss">
.project-box {
    position: relative;
    width: 100%;
    padding-top: 100%;
    .project-box-content {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        text-align: center;
        .md-card-actions {
            position: absolute;
            bottom: 0;
            text-align: right;
            width: 100%;
        }
        overflow: hidden;
    }
}
</style>


// WEBPACK FOOTER //
// project-box.vue?20a5172c